/** Final placing bands, including tied places in elimination brackets. */
export const PLACEMENT_SCORING = [
  { from: 1, to: 1, points: 15 },
  { from: 2, to: 2, points: 12 },
  { from: 3, to: 3, points: 11 },
  { from: 4, to: 4, points: 10 },
  { from: 5, to: 6, points: 9 },
  { from: 7, to: 8, points: 8 },
  { from: 9, to: 12, points: 6 },
  { from: 13, to: 16, points: 5 },
  { from: 17, to: 24, points: 4 },
  { from: 25, to: 32, points: 3 },
  { from: 33, to: 48, points: 2 },
  { from: 49, to: 64, points: 1 },
] as const;
export function pointsForPlacement(
  placement: number | null | undefined,
): number {
  if (placement == null || !Number.isInteger(placement)) return 0;
  return (
    PLACEMENT_SCORING.find(
      (band) => placement >= band.from && placement <= band.to,
    )?.points ?? 0
  );
}
